export const PHONE_DISPLAY = "07404 686518";
export const PHONE_TEL = "tel:07404686518";

export const EMAIL = "edtsolutionsuk@hotmail.com";
export const EMAIL_MAILTO = "mailto:edtsolutionsuk@hotmail.com";

export const INSTAGRAM_HANDLE = "@edtsolutionsuk";
export const INSTAGRAM_URL = "https://www.instagram.com/edtsolutionsuk/";

export const TIKTOK_HANDLE = "@edtsolutions";
export const TIKTOK_URL = "https://www.tiktok.com/@edtsolutions";

export const SNAPCHAT_HANDLE = "edtsolutions";
export const SNAPCHAT_URL = "https://snapchat.com/t/XRtnYu5j";
